module.exports = __webpack_public_path__ + "static/media/xylophone-arpeggio.97d73630.webm";